<template>
  <el-autocomplete
    ref="autocomplete"
    v-model="val"
    class="inline AProductSelector"
    value-key="name"
    :placeholder="place_holder"
    :size="size"
    :fetch-suggestions="searchQuery"
    :trigger-on-focus="false"
    :disabled="disabled"
    :debounce="0"
    :clearable="clearable"
    @input="handleInput"
    @select="handleSelect"
    @clear="handleClear"
    @keydown.enter.native="searchCode"
    @keydown.native="handleKeyDown"
  />
</template>
<script>
import { mapGetters } from "vuex";
import { auto_complete } from "@/common/mixins/auto_complete";

export default {
  name: "AProductSelector",
  mixins: [auto_complete],
  data() {
    return {};
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    showSaleOnly: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    value: function(val) {
      this.val = val;
    },
  },
  created() {
    this.placeHolder = "제품";
  },
  computed: {
    ...mapGetters(["table_product", "table_sale_type"]),
    items: function() {
      let items = [];
      if (this.showSaleOnly) {
        let sale_flags = this.table_sale_type
          .filter((item) => item.sale_flag === "Y")
          .map((item) => item.id);
        items = this.table_product.filter(
          (item) =>
            sale_flags.includes(item.sale_type_id) && item.use_flag !== "N"
        );
      } else {
        items = this.table_product.filter((item) => item.use_flag !== "N");
      }
      return items;
    },
  },
  methods: {
    handleBlur() {
      if (this.results.length !== 1) {
        return;
      }
      this.$emit("select", this.results[0]);
    },
    handleKeyDown(e) {
      // 탭키로 이동 못 하게 수정
      if (e.keyCode === 9) {
        e.returnValue = false;
        this.$refs.autocomplete.activated = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.AProductSelector {
  width: calc(100% - 20px);
}
</style>
